// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CAttachment_abstract } from './../abstract/SagaSchema/CAttachment_abstract';

export class CAttachment extends CAttachment_abstract {
  callcard: CallCard;

  get text() {
    return this.Title;
  }

  get icon() {
    return 'attach';
  }
}
